import type { Guest } from "../services/schedulerApi";

export const MAX_GUESTS = 5;
export const GUEST_EMAIL = /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/;

/** Guests with an email, trimmed; null when any filled-in email is invalid. */
export function cleanGuests(guests: Guest[]): Guest[] | null {
  const filled = guests.map((g) => ({ email: g.email.trim().toLowerCase(), name: g.name.trim() }))
    .filter((g) => g.email || g.name);
  return filled.every((g) => GUEST_EMAIL.test(g.email)) ? filled : null;
}
